import { DEFAULT_LANGUAGE } from '../constants/languages';
import {
    LANGUAGE_DIRECTION_STORAGE_KEY,
    LANGUAGE_STORAGE_KEY,
} from '../constants/translationConfig';
import { isValidLanguageCode } from './languageList';

/**
 * The chosen language and its text direction are both saved. The direction is kept so the page
 * (see the small script in public/index.html) can be set right-to-left before the language list
 * has loaded.
 */

/** The language the user chose last time, or the default if none/invalid/storage unavailable. */
export const getStoredLanguage = () => {
    try {
        const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
        return isValidLanguageCode(stored) ? stored : DEFAULT_LANGUAGE;
    } catch {
        return DEFAULT_LANGUAGE;
    }
};

export const getStoredDirection = () => {
    try {
        return window.localStorage.getItem(LANGUAGE_DIRECTION_STORAGE_KEY) === 'rtl' ? 'rtl' : 'ltr';
    } catch {
        return 'ltr';
    }
};

export const storeLanguage = (code, dir = 'ltr') => {
    try {
        window.localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
        window.localStorage.setItem(LANGUAGE_DIRECTION_STORAGE_KEY, dir === 'rtl' ? 'rtl' : 'ltr');
    } catch {
        /* storage blocked: the choice simply won't persist */
    }
};
